export class Site {
  id: number;
  x: number;
  y: number;
}
